common:
  save: Сохранить
animations:
  stage-transitions:
    title: Отключить переходы между сценами
  use-page-specific-transitions:
    description: >-
      Некоторые страницы имеют свои собственные переходы — они будут переопределять переходы сцен
    title: Использовать переходы для страниц
dialogs:
  onboarding:
    title: Добро пожаловать в AIRI!
    description: Давайте настроим вашего первого AI-провайдера, чтобы начать работу.
    selectProvider: Выберите AI-провайдера
    configureProvider: Настроить {provider}
    apiKey: API-ключ
    apiKeyHelp: Получите API-ключ у {provider} и вставьте его сюда
    baseUrl: Базовый URL
    baseUrlHelp: URL конечной точки API (оставьте по умолчанию, если не уверены)
    accountId: ID аккаунта
    validationSuccess: Configuration validation success
    validationFailed: Проверка конфигурации не удалась
    validationError: 'Ошибка проверки: {error}'
    skipForNow: Пропустить на сейчас
    saveAndContinue: Сохранить и продолжить
    next: Далее
    retry: Retry
    start: Поехали!
    select-model: Выберите модель
    no-models: Нет доступных моделей
    no-models-help: >-
      Вернитесь на предыдущий шаг и проверьте API-ключ или подключение к сети.
language:
  title: Language
  description: >
    Change the language of the AIRI interface. This will not affect the language of the character's responses.
controls-island:
  icon-size:
    title: Controls Island Icon Size
    description: Adjust the size of the controls island icons
    auto: Auto (responsive)
    large: Large (default)
    small: Small
live2d:
  change-model:
    from-file: Загрузить из файла
    from-file-select: Выбрать
    from-url: Загрузить по URL
    from-url-confirm: Загрузить
    from-url-placeholder: Введите URL модели Live2D
    title: Сменить модель
  edit-motion-map:
    title: Редактировать карту движений
  map-motions:
    play: Воспроизвести движение
    title: Карта движений
  title: Настройки Live2D
  scale-and-position:
    title: Масштаб и позиция
    scale: Масштаб
    x: X
    'y': 'Y'
  switch-to-vrm:
    title: Переключиться на 3D-аватар?
    change-to-vrm: Нажмите здесь, чтобы переключиться на настройки 3D-аватара (VRM)
  theme-color-from-model:
    title: Извлечь цвета из модели
    button-extract:
      title: Извлечь
  focus:
    title: Отключить слежение за мышью
    button-disable:
      title: Отключить
microphone: Микрофон
models: Модель
pages:
  card:
    activate: Активировать
    active: Активно
    active_badge: Текущая
    cancel: Cancel action
    save: Save changes
    card_not_found: Карта не найдена
    character: Персонаж
    close: Закрыть
    consciousness:
      model: Сознание / Модель
    created_by: создано
    creator_notes: Заметки автора
    delete: Удалить
    delete_card: Удалить карту
    delete_confirmation: Вы уверены, что хотите удалить эту карту?
    description: Используйте предустановленные карты персонажей AIRI
    description_label: Описание
    drop_here: Перетащите сюда для загрузки
    create_card: Создать новую карту
    edit_card: Edit Card
    creation:
      identity: Личность
      name: Имя
      nickname: Ник
      description: Описание
      behavior: Поведение
      greetings: Приветствия (по одному на строку)
      settings: Настройки
      version: Версия
      create: Создать
      defaults:
        name: Имя
        personality: Вы обычный человек, любопытный ко всему.
        scenario: Вы недавно проснулись и забыли всё о прошлой жизни.
        systemprompt: Вы будете получать сообщения, отвечайте на них как настоящий человек.
        posthistoryinstructions: Не забывайте подражать человеку.
      fields_info:
        subtitle: >-
          Здесь можно указать детали о создаваемом персонаже, описать его историю, контекст и то, как он должен отвечать на взаимодействия.
        name: Формальное имя персонажа.
        nickname: Можно дать ник, который будет приоритетным.
        description: Описание персонажа.
        notes: Личные заметки.
        personality: >-
          Опишите личность персонажа. Застенчивый? Любопытный? Что угодно.
        scenario: Его местоположение? В какой он ситуации?
        greetings_field: Приветствия
        greetings: Как персонаж должен здороваться?
        systemprompt: Опишите, как AI должен отвечать на запросы.
        posthistoryinstructions: Укажите, что AI должен учитывать после истории сообщений.
        version: >-
          Версия карты. Увеличьте число, если изменяете предыдущую карту.
      errors:
        name: Имя должно быть корректным и непустым.
        version: 'Ошибка: неверная версия!'
        description: 'Ошибка: необходимо указать описание карты.'
        personality: 'Ошибка: необходимо указать личность персонажа.'
        scenario: 'Ошибка: требуется сценарий.'
        systemprompt: 'Ошибка: укажите системный промпт.'
        posthistoryinstructions: 'Ошибка: требуется post-history промпт.'
    modules: Модули
    name_asc: Имя (А-Я)
    name_desc: Имя (Я-А)
    no_cards: Карточек пока нет. Нажмите кнопку выше, чтобы загрузить!
    no_results: Карточки не найдены :(
    personality: Личность
    posthistoryinstructions: Инструкции после истории
    recent: Недавно добавленные
    scenario: Сценарий
    search: Искать карточки...
    sort_by: Сортировать по
    speech:
      model: Речь / Модель
      voice: Речь / Голос
    systemprompt: Системный промпт
    title: Карта AIRI
    try_different_search: Попробуйте другой поисковый запрос
    upload: Загрузить
    upload_desc: Нажмите или перетащите файл для загрузки
  memory:
    description: Хранилище и организация воспоминаний
    title: Память
  data:
    title: Data
    description: Manage stored AIRI data, exports, and resets
    sections:
      chats:
        title: Chat sessions
        description: Export or import saved chat sessions.
        export: Export chats
        import: Import chats
        delete: Delete all chat sessions
      models:
        title: Models
        description: Remove imported Live2D/VRM models.
        delete: Delete all models
      modules:
        title: Modules
        description: Reset module preferences and credentials.
        reset: Reset module settings
      providers:
        title: Providers
        description: Reset all provider settings and credentials.
        reset: Reset provider settings
      danger:
        title: Danger zone
        description: Irreversible actions. Export what you need before continuing.
      all:
        title: Delete all data
        description: Wipe every local setting, provider config, and model.
        delete: Delete all data
      desktop:
        title: Reset desktop settings & states
        description: Clear AIRI desktop settings and runtime state.
        reset: Reset desktop data
    confirmations:
      tooltip: Are you sure?
      'yes': 'Yes'
    status:
      exported: Chat sessions exported.
      imported: Chat sessions imported.
      import_error: Failed to import chat sessions. Please check the file format.
      chats_deleted: Chat sessions deleted.
      models_deleted: Models deleted.
      modules_reset: Module settings reset.
      providers_reset: Provider settings reset.
      all_deleted: All local data deleted.
      desktop_reset: Desktop data reset.
  models:
    description: Live2D, VRM и др.
    title: Модели
    sections:
      section:
        live2d:
          title: Live2D
          description: Настройка моделей Live2D
        vrm:
          title: VRM
          description: Настройка 3D-моделей VRM
        scene: Сцена
  modules:
    beat_sync:
      description: Vibe with beats from the audio source
      title: Beat Sync
      sections:
        audio_source:
          actions:
            start_screen_capture: Start screen capture
            stop: Stop
          description: Select an audio source to detect beats from.
          title: Audio source
        beat_visualizer:
          title: Beat visualizer
        parameters:
          advanced_parameters: Advanced Parameters
          description: Tweak the beat detection parameters.
          title: Parameters
          parameters:
            adaptive_threshold:
              description: >-
                Whether to apply adaptive thresholds based on signal variance over time.
              label: Adaptive threshold
            buffer_duration:
              description: Duration of the internal analysis buffer.
              label: Buffer duration
            envelope_filter_frequency:
              description: >-
                Frequency for the envelope filter applied to smooth energy changes.
              label: Envelope filter frequency
            highpass_filter_frequency:
              description: >-
                Frequency for the highpass filter applied to reduce low frequencies like sub-bass noises.
              label: Highpass filter frequency
            lowpass_filter_frequency:
              description: >-
                Frequency for the lowpass filter applied to reduce high frequencies like vocals.
              label: Lowpass filter frequency
            min_beat_interval:
              description: Maximum BPM or minimum interval between detected beats.
              label: Max BPM / Min beat interval
            sensitivity:
              label: Sensitivity
            spectral_flux:
              description: Whether to enable spectral flux-based onset detection.
              label: Spectral flux
            warmup:
              description: Whether to warm up before detecting beats for better accuracy.
              label: Warmup
    consciousness:
      description: Личность, модель сознания и др.
      sections:
        section:
          provider-model-selection:
            collapse: Свернуть
            custom_model_placeholder: Введите название кастомной модели...
            description: Выберите подходящего LLM-провайдера для сознания
            error: Ошибка загрузки моделей
            health_check_failed: Health check failed
            no_providers_configured_title: No Providers Configured
            no_providers_configured_description: Click here to set up your LLM providers
            expand: Развернуть
            loading: Загрузка доступных моделей...
            manual_model_name: Название модели
            manual_model_placeholder: Введите имя модели для использования
            no_models: Моделей нет
            no_models_description: Для этого провайдера модели не найдены
            no_search_results: Совпадений нет
            no_search_results_description: Моделей, соответствующих '{query}', не найдено.
            not_supported: Список моделей не поддерживается
            not_supported_description: Этот провайдер не поддерживает вывод списка моделей
            search_placeholder: Поиск моделей...
            search_results: Найдено {count} из {total} моделей
            show_less: Показать меньше
            show_more: Показать больше
            subtitle: Выберите модель у провайдера
            title: Модель
      title: Сознание
    description: Мыслительный процесс, зрение, синтез речи, игры и т. д.
    gaming-factorio:
      description: Играем в Factorio!
      title: Factorio
      enable: Включить интеграцию Factorio
      enable-description: Разрешить AIRI взаимодействовать с игрой Factorio
      server-address: Адрес сервера
      server-address-description: IP-адрес или имя хоста сервера Factorio
      server-address-placeholder: Введите адрес сервера (например, localhost или 192.168.1.100)
      server-port: Порт сервера
      server-port-description: Номер порта сервера Factorio (по умолчанию 34197)
      username: Имя пользователя
      username-description: Ваше имя пользователя на сервере Factorio
      username-placeholder: Введите ваше имя пользователя Factorio
      configured: Factorio настроен правильно!
    gaming-minecraft:
      description: Играем в Minecraft!
      title: Minecraft
      enable: Включить интеграцию Minecraft
      enable-description: Разрешить AIRI взаимодействовать с игрой Minecraft
      server-address: Адрес сервера
      server-address-description: IP-адрес или имя хоста сервера Minecraft
      server-address-placeholder: Введите адрес сервера (например, localhost или play.example.com)
      server-port: Порт сервера
      server-port-description: Номер порта сервера Minecraft (по умолчанию 25565)
      username: Имя пользователя
      username-description: Ваше имя пользователя на сервере Minecraft
      username-placeholder: Введите ваше имя пользователя Minecraft
      configured: Minecraft настроен правильно!
    hearing:
      description: Настройка распознавания речи
      title: Слух
      sections:
        section:
          provider-selection:
            description: Select the suitable speech recognition provider
    memory-long-term:
      description: Настройки долговременной памяти
      title: Долговременная память
    memory-short-term:
      description: Настройки кратковременной памяти
      title: Кратковременная память
    messaging-discord:
      description: Чат и голосовой чат через Discord
      title: Discord
      enable: Включить интеграцию Discord
      enable-description: Разрешить AIRI взаимодействовать через Discord
      token: Токен бота
      token-description: Ваш токен бота Discord
      token-placeholder: Введите токен бота Discord
      configured: Discord настроен правильно!
    speech:
      description: Синтез речи
      sections:
        section:
          playground:
            buttons:
              stop:
                label: Стоп
            select-voice:
              required: Выберите голос
          provider-voice-selection:
            custom_model_placeholder: Введите название кастомной модели...
            custom_voice_placeholder: Введите ID кастомного голоса...
            description: Выберите подходящего провайдера синтеза речи
            no_models: Моделей нет
            no_models_description: Модели не найдены
            no_voices: Голосов нет
            no_voices_description: Голоса не найдены
            no_voices_hint: You can enter a custom voice name below.
            pause: Пауза
            play_sample: Воспроизвести пример
            search_models_placeholder: Поиск моделей...
            search_models_results: Найдено {count} из {total} моделей
            search_voices_placeholder: Поиск голосов...
            search_voices_results: Найдено {count} из {total} голосов
            unsupported_voice_warning_title: No supported voices
            unsupported_voice_warning_content: >-
              Try a different model or provider. We are working on supporting all the voice for this model as quickly as possible. If you need it urgently, please let us know on GitHub at https://github.com/moeru-ai/airi/issues.
            show_less: Показать меньше
            show_more: Показать больше
            title: Провайдер
          voice-settings:
            input-ssml:
              placeholder: Введите SSML-текст...
            use-ssml:
              description: Включите для ввода SSML вместо обычного текста
              label: Использовать кастомный SSML
      title: Речь
    title: Модули
    vision:
      description: Зрение
      title: Зрение
    x:
      description: Просмотр и использование X / Twitter
      title: X / Twitter
      enable: Включить интеграцию X / Twitter
      enable-description: Разрешить AIRI взаимодействовать с X / Twitter
      api-key: API-ключ
      api-key-description: Ваш API-ключ X / Twitter
      api-key-placeholder: Введите ваш API-ключ X / Twitter
      api-secret: API-секрет
      api-secret-description: Ваш API-секрет X / Twitter
      api-secret-placeholder: Введите ваш API-секрет X / Twitter
      access-token: Токен доступа
      access-token-description: Ваш токен доступа X / Twitter
      access-token-placeholder: Введите ваш токен доступа X / Twitter
      access-token-secret: Секрет токена доступа
      access-token-secret-description: Ваш секрет токена доступа X / Twitter
      access-token-secret-placeholder: Введите ваш секрет токена доступа X / Twitter
      configured: X / Twitter настроен правильно!
    mcp-server:
      description: Подключение и управление MCP-сервером и инструментами
      title: MCP-сервер
  providers:
    explained:
      chat: Провайдеры текстогенерации, напр. OpenRouter, OpenAI, Ollama.
      Speech: Провайдеры речи (TTS), напр. ElevenLabs, Azure Speech.
      Transcription: >-
        Провайдеры транскрипции (STT): Whisper.cpp, OpenAI, Azure Speech.
    helpinfo:
      title: Впервые здесь?
      description: >
        AIRI требует как минимум одного {chat}-провайдера для корректной работы. Можно считать его "мозгом" персонажей в системе AIRI.
    catalog:
      edit:
        config-id-not-found: Provider configuration not found.
        definition-id-not-found: Provider definition not found.
        actions:
          more-options: More options
          delete: Delete
        validation:
          failed:
            title: Please check your provider settings, validation failed.
            description: You can still save the current configuration if you want to proceed.
            action: Save anyway
        config:
          common:
            fields:
              field:
                api-key:
                  label: API Key
                  description: API Key used to authorize requests to this provider
                  placeholder: sk-...
                base-url:
                  label: Base URL
                  description: >-
                    The base url used to connect to remote service. Often looks like http://localhost:11434/v1 or https://example.com/v1.
                  placeholder: Base url...
                headers:
                  label: Custom HTTP Headers
                  description: Add custom HTTP headers
                  key:
                    placeholder: Key
                  value:
                    placeholder: Value
        validators:
          actions:
            validate: Validate
          empty: No validation steps available.
          openai-compatible:
            check-config:
              title: Configuration
            check-connectivity:
              title: Connectivity
            check-supports-model-listing:
              title: List Models
            check-supports-chat-completion:
              title: Chat Completion
          status:
            validating: Validating...
            valid: Passed
            invalid: Errored
          title: Checks
        providers:
          provider:
            ollama:
              troubleshooting:
                validators:
                  openai-compatible-check-connectivity:
                    label: Extra configuration needed for Ollama
                    content: >-
                      Sorry to hear that Connectivity check failed for Ollama. Don't worry, for Ollama instances, extra configuration is needed for making it pass for Ollama. You need to set <code>OLLAMA_HOST</code> explicitly when start the Ollama application or Ollama CLI server, for detailed information, check <a href="https://airi.moeru.ai/docs/en/docs/manual/integrations/providers/chat/ollama">Ollama integration guide</a>.
    common:
      continueAnyway: Продолжить всё равно
      fields:
        field:
          api-key:
            label: Ввод API-ключа
      section:
        advanced:
          fields:
            field:
              headers:
                description: Добавить кастомные HTTP-заголовки
                key:
                  placeholder: Ключ
                label: HTTP-заголовки
                value:
                  placeholder: Значение
          title: Дополнительно
        basic:
          description: Основные настройки
          title: Базовые
        voice:
          title: Настройки голоса
    description: LLM-модели, провайдеры речи и др.
    provider:
      app-local-audio-transcription:
        title: Приложение (локально)
        description: https://github.com/moeru-ai/xsai-transformers
      app-local-audio-speech:
        title: Приложение (локально)
        description: https://github.com/moeru-ai/xsai-transformers
      browser-local-audio-transcription:
        title: Браузер (локально)
        description: https://github.com/moeru-ai/xsai-transformers
      browser-local-audio-speech:
        title: Браузер (локально)
        description: https://github.com/moeru-ai/xsai-transformers
      alibaba-cloud-model-studio:
        description: bailian.console.aliyun.com
        title: Alibaba Cloud Model Studio
      anthropic:
        description: anthropic.com
        title: Anthropic | Claude
        helpinfo:
          title: Перед началом
          description:
            part1: >-
              Хотя Anthropic недавно объявили о бета-поддержке совместимости с OpenAI SDK
            part2: (подробнее здесь)
            part3: но из-за особенностей реализации есть
            part4: >-
              ограничения, не совпадающие со спецификой OpenAI SDK, поэтому сейчас использовать этого провайдера в браузере нельзя.
            part5: >-
              Если провайдер необходим, нужен выделенный прокси-бэкенд (например, Serverless Function)
            part6: или сервисы обхода CORS для снятия ограничений CORS.
      cloudflare-workers-ai:
        description: cloudflare.com
        fields:
          field:
            account-id:
              description: ID аккаунта Cloudflare
              label: Account ID
              placeholder: Ваш Cloudflare Account ID
            api-key:
              placeholder: Введите Cloudflare API Key
        title: Cloudflare Workers AI
      common:
        status:
          validating: Validating
          valid: Configuration seems to be valid.
        fields:
          field:
            pitch:
              description: Настроить высоту синтезируемой речи (острее/грубее)
              label: Высота
            speed:
              description: Регулировка скорости речи
              label: Скорость
            volume:
              description: Регулировка громкости речи
              label: Громкость
      deepgram-tts:
        description: deepgram.com
        title: Deepgram
      deepseek:
        description: deepseek.com
        title: DeepSeek
      elevenlabs:
        description: elevenlabs.io
        fields:
          field:
            simularity-boost:
              description: Степень сохранения сходства голоса
              label: Similarity Boost
            speaker-boost:
              description: Усиление схожести с диктором
              label: Speaker Boost
            speed:
              description: Скорость генерации речи
              label: Speed
            stability:
              description: Стабильность/случайность голоса
              label: Stability
            style:
              description: Выразительность/стиль голоса
              label: Style
        playground:
          buttons:
            button:
              test-voice:
                generating: Генерация...
                label: Протестировать голос
          fields:
            field:
              input:
                placeholder: Введите текст для теста голоса...
              language:
                description: Выберите язык голоса
                label: Язык
              voice:
                description: Выберите предпочтительный голос
                label: Голос
          title: Песочница голоса
          validation:
            error-missing-api-key: Введите API-ключ, чтобы протестировать голос.
        title: ElevenLabs
      fireworks:
        description: fireworks.ai
        title: Fireworks.ai
      microsoft-speech:
        description: speech.microsoft.com
        fields:
          field:
            region:
              description: Регион Speech Service
              label: Регион
        title: Microsoft / Azure Speech
      index-tts-vllm:
        description: https://index-tts.github.io/
        title: Bilibili / IndexTTS
      azure-ai-foundry:
        description: Azure AI Foundry
        title: Azure AI Foundry
      mistral:
        description: mistral.ai
        title: Mistral
      moonshot:
        description: moonshot.ai
        title: Moonshot AI
      modelscope:
        description: modelscope.cn
        title: ModelScope
      novita:
        description: novita.ai
        title: Novita
      ollama:
        description: ollama.ai
        title: Ollama
      openai:
        description: openai.com
        title: OpenAI
      openai-compatible:
        description: Совместимый с OpenAI
        title: OpenAI Compatible
      openrouter:
        description: openrouter.ai
        title: OpenRouter
      perplexity:
        description: perplexity.ai
        title: Perplexity
      player2:
        description: player2.game
        title: Player2
      together:
        description: together.ai
        title: Together.ai
      google-generative-ai:
        description: gemini.google.com
        title: Google Gemini
      groq:
        description: groq.com
        title: Groq
      featherless:
        description: featherless.ai
        title: Featherless AI
      lm-studio:
        description: lmstudio.ai
        title: LM Studio
      vllm:
        description: vllm.ai
        title: vLLM
      volcengine:
        description: volcengine.com
        fields:
          field:
            appId:
              description: App ID проекта (получается в Console)
              label: App ID
        title: Volcano Engine
      xai:
        description: x.ai
        title: xAI
      302-ai:
        description: 302.AI
        title: 302.AI
      comet-api:
        description: CometAPI.com
        title: Comet API
      cerebras:
        description: cerebras.ai
        title: Cerebras
      aliyun-nls:
        description: Aliyun NLS
        title: Aliyun NLS
      browser-web-speech-api:
        description: Browser-native STT (requires Chrome/Edge/Safari)
        title: Web Speech API
      transcriptions:
        playground:
          title: Песочница транскрипции
    title: Провайдеры
  connection:
    description: Configure WebSocket server connection
    title: Connection
    websocket-url:
      description: Full address of the WebSocket server (e.g., ws://localhost:6121/ws)
      label: WebSocket Server Address
      placeholder: ws://localhost:6121/ws
  scene:
    description: Настройте окружение, в котором живёт персонаж
    title: Сцена
  system:
    color-scheme:
      description: Изменить цветовую схему сцены
      title: Цветовая схема
    developer:
      description: Опции разработчика
      title: Разработчики
    general:
      description: Тема, языки и др.
      title: Общие
    description: Настройте вашу сцену!
    sections:
      section:
        custom-color:
          fields:
            field:
              primary-color:
                label: Основной цвет
                rgb-on:
                  title: Хочу динамический!
          title: Цветовая схема
        developer:
          title: Разработчик
          sections:
            section:
              performance-visualizer:
                title: Performance Visualizer
                description: Toggle FPS/long task/memory overlay
              markdown-stress:
                title: Markdown Stress
                description: Stress markdown parsing and rendering with heavy chat payloads
              use-magic-keys:
                title: useMagicKeys
                description: Test shortcuts
        theme-presets:
          presets:
            default:
              colors:
                color-1: AIRI Green
              description: The default greenish theme color, brought by AIRI to you!
              title: Default Color
            morandi:
              colors:
                color-1: Taupe
                color-2: Beige
                color-3: Ash Grey
                color-4: Light Taupe
                color-5: Ivory
                color-6: Olive Grey
                color-7: Sand
                color-8: Warm Grey
              description: Soft, muted tones inspired by Giorgio Morandi's paintings
              title: Morandi Colors
            monet:
              colors:
                color-1: Sky Blue
                color-2: Mist
                color-3: Sand
                color-4: Moss Green
                color-5: Water Lily
                color-6: Wheat
                color-7: Slate Blue
                color-8: Sage
              description: Impressionist palette inspired by Claude Monet's works
              title: Monet Colors
            japanese:
              colors:
                color-1: Tan
                color-2: Warm Taupe
                color-3: Umber
                color-4: Coffee
                color-5: Bronze
                color-6: Gold
                color-7: Mustard
                color-8: Amber
              description: Traditional Japanese color palette
              title: Japanese Colors
            nordic:
              colors:
                color-1: Nordic Blue
                color-2: Ice
                color-3: Fjord
                color-4: Steel
                color-5: Glacier
                color-6: Slate
                color-7: Cloud
                color-8: Stone
              description: Scandinavian minimalist color scheme
              title: Nordic Colors
            chinese:
              colors:
                color-1: Rosy Dawn
                color-2: Chinese Red
                color-3: Smoky Brown
                color-4: Bamboo Green
                color-5: Dark Purple
                color-6: Golden Yellow
                color-7: Azure Blue
                color-8: Ochre
              description: >-
                Traditional Chinese colors, derived from ancient textiles, porcelain and paintings
              title: Chinese Traditional Colors
          title: Наборы цветовых схем
    title: Внешний вид
  page:
    developers:
      open-devtools:
        title: Open Developer Tools
        button: Open
sections:
  section:
    general:
      title: Общие
theme:
  title: Тема
  description: |
    Переключение основной темы AIRI: светлая или тёмная.
title: Настройки
voices: Голос
vrm:
  change-model:
    from-file: Загрузить из файла
    from-file-select: Выбрать
    from-url: Загрузить по URL
    from-url-confirm: Загрузить
    from-url-placeholder: Введите URL модели VRM
    title: Смена модели
  title: Настройки VRM
  scale-and-position:
    model-info-title: Информация о размере модели
    model-info-x: Ширина (X)
    model-info-y: Высота (Y)
    model-info-z: Глубина (Z)
    tips: |
      Настройте начальную позицию модели VRM.
      Оси координат визуализированы.
    scale: Масштаб
    x: Смещение по X
    'y': Смещение по Y
    z: Смещение по Z
    fov: Угол обзора (градусы)
    rotation-y: Вращение (ось Y)
    camera-distance: Дистанция камеры
    eye-tracking-mode:
      title: Смотреть на
      options:
        option:
          camera: Камеру
          mouse: Мышь
          disabled: Отключено
  switch-to-vrm:
    title: Переключиться на аватар Live2D?
    change-to-vrm: Нажмите здесь, чтобы переключиться на настройки Live2D
  theme-color-from-model:
    button-extract:
      title: Извлечь
  skybox:
    skybox-intensity: SkyBox Intensity
    skybox-specular-mix: Specular Mix
wip:
  title: Work in Progress
  description: >-
    This feature is currently under development and not yet publicly available. Check back in future updates for this functionality.
